import React from 'react';
import { useAuth0 } from '@client/helperComponents/react-auth0-spa';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import ReactLink from '@client/components/reactLink/ReactLink';
import { AUTH_0_SIGN_UP } from '@client/definitions/constants';
import { trackCustomEvent } from '@client/tracking/GTM';
import {
  EVENT_GA,
  CATEGORY_PROMO_FULL_WIDTH,
  ACTION_BTN_CLICK,
} from '@client/definitions/tracking';
import styles from './hero.scss';

export const Hero = ({
  heading,
  description,
  textCreateAccount,
  textLogin,
  textCreateFundraiser,
  imageMobile,
  imageDesktop,
}) => {
  const auth = useAuth0();
  const isAuthenticated = auth?.isAuthenticated;
  const imageMobileUrl = getIn(imageMobile, 'file', 'url');
  const imageMobileDesc = getIn(imageMobile, 'description');
  const imageDesktopUrl = getIn(imageDesktop, 'file', 'url');
  const imageDesktopDesc = getIn(imageDesktop, 'description');

  const trackHeroButtonClick = (clickText) => {
    trackCustomEvent(EVENT_GA, {
      click_category: CATEGORY_PROMO_FULL_WIDTH,
      click_type: ACTION_BTN_CLICK,
      click_text: clickText,
    });
  };

  const handleLogin = () => {
    auth?.loginWithRedirect({
      appState: { targetUrl: '/' },
    });
    trackHeroButtonClick(textLogin);
  };

  const handleSignUp = () => {
    auth.loginWithRedirect({
      screen_hint: AUTH_0_SIGN_UP,
      appState: { targetUrl: '/skapa/insamling' },
    });
    trackHeroButtonClick(textCreateAccount);
  };

  return (
    <div className={styles.container}>
      <div className={styles.overlay}>
        <div className={styles.content}>
          <div className={styles.box}>
            {heading && <h1 className={styles.heading}>{heading}</h1>}
            {description && <p className={styles.paragraph}>{description}</p>}

            <div className={styles.buttonContainer}>
              {!isAuthenticated && (
                <>
                  {textCreateAccount && (
                    <button
                      className={`${styleHelper.btnPrimaryMd} ${styles.button}`}
                      onClick={handleSignUp}
                    >
                      {textCreateAccount}
                    </button>
                  )}
                  {textLogin && (
                    <button
                      onClick={handleLogin}
                      className={`${styleHelper.btnSecondaryMd} ${styles.buttonSecondary}`}
                    >
                      {textLogin}
                    </button>
                  )}
                </>
              )}
              {isAuthenticated && textCreateFundraiser && (
                <ReactLink
                  className={`${styleHelper.btnPrimaryMd} ${styles.button}`}
                  to={'/skapa/insamling/'}
                  onClick={() => trackHeroButtonClick(textCreateFundraiser)}
                >
                  {textCreateFundraiser}
                </ReactLink>
              )}
            </div>
          </div>
        </div>
      </div>
      {imageMobileUrl && (
        <img
          className={styles.imageMobile}
          alt={imageMobileDesc ? imageMobileDesc : ''}
          src={`${imageMobileUrl}?w=750&h=825&q=90&fm=webp`}
        />
      )}
      {imageDesktopUrl && (
        <img
          className={styles.image}
          alt={imageDesktopDesc ? imageDesktopDesc : ''}
          src={`${imageDesktopUrl}?w=1920&h=690&q=90&fm=webp`}
        />
      )}
    </div>
  );
};
